export default __webpack_public_path__ + "static/media/wide_row_start.57ee6fdb.svg";